import { QUOTE_PAYMENT_TERM_MAX_CODE_LENGTH } from './quote-payment-term-code.constants';
import {
  IQuotePaymentTermCode,
  IQuotePaymentTermCodeData,
  IQuotePaymentTermCodeFieldError,
  IQuotePaymentTermCodeFieldErrorData
} from './quote-payment-term-code.types';

export class QuotePaymentTermCode implements IQuotePaymentTermCode {
  id?: number;
  code: string;

  constructor(data: IQuotePaymentTermCodeData) {
    // Validate data
    this.validate(data);

    this.code = data.code!;

    if (data.id) {
      this.id = data.id;
    }
  }

  private validate(data: IQuotePaymentTermCodeData): void {
    const requiredFields: (keyof IQuotePaymentTermCodeData)[] = ['code'];

    for (const field of requiredFields) {
      if (!data[field]) {
        throw new Error(`Invalid or missing '${field}' property`);
      }
    }

    // ensure code is valid
    if (data.code!.length > QUOTE_PAYMENT_TERM_MAX_CODE_LENGTH) {
      throw new Error(
        `Code exceeds maximum length of ${QUOTE_PAYMENT_TERM_MAX_CODE_LENGTH} characters`
      );
    }
  }

  toString(): string {
    return this.code;
  }
}

export class QuotePaymentTermCodeFieldError
  implements IQuotePaymentTermCodeFieldError {
  code: string[] = [];

  constructor(data?: IQuotePaymentTermCodeFieldErrorData) {
    if (data) {
      if (data.code) {
        this.code = data.code;
      }
    }
  }

  clearErrors(): void {
    this.code.splice(0, this.code.length);
  }

  static isQuotePaymentTermCodeFieldError(
    data: IQuotePaymentTermCodeFieldErrorData
  ): boolean {
    if (data.code && Array.isArray(data.code)) {
      return true;
    }

    return false;
  }
}
